import { createSlice } from '@reduxjs/toolkit';
import newsProvider from 'data-access/news-provider';
import { DEFAULT_PAGE, PAGE_SIZE } from './configs';
// import uploadProvider from "@data-access/upload-provider";
import type { Category, News } from 'types';
import { RootState } from 'app/store';

interface ListPostState {
  listCategories: Category[];
  categoryIdSelected: null | number;
  childCategoryIdSelected: null | number;
  listNews: News[];
  currentPage: number;
  pageSize: number;
  totalItems: null | number;
  isLoading: boolean;
  searchText: null | string;
  orderBy: Array<string>;
}

interface NewsParam {
  currentPage?: number;
  pageSize?: number;
  searchText?: string | null;
  categoryId?: number | null;
  orderBy?: Array<string>;
}

const initialState: ListPostState = {
  listCategories: [],
  categoryIdSelected: null,
  childCategoryIdSelected: null,
  listNews: [],
  currentPage: DEFAULT_PAGE,
  pageSize: PAGE_SIZE,
  totalItems: null,
  isLoading: false,
  searchText: null,
  orderBy: []
};

export const listPostSlice = createSlice({
  name: 'listPosts',
  initialState,
  reducers: {
    updateData: (state, action) => {
      const data = action.payload || {};
      const keys = Object.keys(data);
      keys.forEach((key) => {
        state[key] = data[key];
      });
    },
    updateListCategories: (state, action) => {
      state.listCategories = action.payload;
    },
    updateListNews: (state, action) => {
      state.listNews = action.payload.listNews;
      state.currentPage = action.payload.currentPage;
      state.totalItems = action.payload.totalItems;
    }
  }
});

export const { updateData, updateListNews, updateListCategories } = listPostSlice.actions;

export const getListCategories = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await newsProvider.getCategories(params);
      dispatch(updateListCategories(res));
    } catch (err) {
      console.error(err);
      // return Promise.reject(err);
    }
  };
};

export const getListNews = (params: NewsParam) => {
  return async (dispatch, getState) => {
    try {
      const {
        listPosts: {
          currentPage,
          pageSize,
          categoryIdSelected,
          childCategoryIdSelected,
          searchText,
          orderBy
        }
      } = getState();
      const currentPageParam = params.currentPage || currentPage;
      const pageSizeParam = params.pageSize || pageSize;
      const orderByParam = params.orderBy || orderBy;
      const title = params.searchText || searchText;
      const categoryId = params.categoryId ?? childCategoryIdSelected ?? categoryIdSelected;

      const paramsNews = {
        page: currentPageParam,
        limit: pageSizeParam,
        categoryId,
        title,
        orderBy: orderByParam.toString()
      };

      const res: any = await newsProvider.getListNews(paramsNews);
      const {
        data,
        pagination: { total }
      } = res;

      dispatch(
        updateListNews({
          listNews: data,
          currentPage,
          pageSize,
          totalItems: total
        })
      );
    } catch (err) {
      console.error(err);
      // return Promise.reject(err);
    }
  };
};

export const deleteNews = (id: number) => {
  return async (dispatch, getState) => {
    const {
      posts: { parentCategoryId, childCategoryId }
    } = getState();
    try {
      await newsProvider.deleteNews(id);

      await dispatch(getListNews({ categoryId: childCategoryId || parentCategoryId }));
    } catch (err) {
      console.error(err);
    }
  };
};

export const selectListCategories = (state: RootState) => state.listPosts.listCategories;
export const selectCategoryIdSelected = (state: RootState) => state.listPosts.categoryIdSelected;
export const selectChildCategoryIdSelected = (state: RootState) =>
  state.listPosts.childCategoryIdSelected;
export const selectListNews = (state: RootState) => state.listPosts.listNews;
export const selectCurrentPage = (state: RootState) => state.listPosts.currentPage;
export const selectPageSize = (state: RootState) => state.listPosts.pageSize;
export const selectTotalItems = (state: RootState) => state.listPosts.totalItems;
export const selectSearchText = (state: RootState) => state.listPosts.searchText;
export const selectOrderBy = (state: RootState) => state.listPosts.orderBy;

export default listPostSlice.reducer;
